import React, { useContext, useEffect, useState, useRef } from "react";

import { ContextSolicitacoes } from "../../../services/solicitacoes";
import { Spinner, BotaoMenor } from "../../StyledComponent";
import Calendar from "../../Reutilizaveis/Calendar-acompanhar-agendamento";
import BaseComponent from "../BaseComponent";
import HeaderStroke from "../../HeaderStroke";
import DropDown from "../../Reutilizaveis/DropDown";
import DropDownDisabled from "../../Reutilizaveis/DropDownDisabled";

import { useHistory } from "react-router-dom";

import "./styles.scss";

const AcompanharAgendamentos = () => {
  const [todosAgendamentos, setTodosAgendamentos] = useState([]);
  const [diasComAgendamentos, setDiasComAgendamentos] = useState([]);
  const [agendamentosImovelSelecionado, setAgendamentosImovelSelecionado] =
    useState([]);
  const [
    agendamentosImovelSelecionadoOriginal,
    setAgendamentosImovelSelecionadoOriginal,
  ] = useState([]);
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState("");

  const [solicitacaoSelecionada, setSolicitacaoSelecionada] = useState({});

  const [imoveis, setImoveis] = useState([]);

  const [imovelSelecionado, setImovelSelecionado] = useState("");

  const [dataAtual, setDataAtual] = useState("");

  const [error, setError] = useState(false);

  const { getAgendamentosAbertos } = useContext(ContextSolicitacoes);

  const history = useHistory();

  useEffect(() => {
    (async function () {
      await loadAgendamentos();
    })();
  }, []);

  useEffect(() => {
    filtraImovel();
  }, [imovelSelecionado]);

  useEffect(() => {
    setSolicitacaoSelecionada([]);
    filtraPorMesSelecionado();
  }, [dataAtual]);

  useEffect(() => {
    if (data != "") {
      let resultItensCalendario = Array.from(
        document.getElementsByClassName("itemDoCalendario")
      );

      resultItensCalendario.forEach((item) => {
        item.classList.remove("item");
      });

      for (let i = 0; i < resultItensCalendario.length; i++) {
        resultItensCalendario[i].classList.remove("item");
        if (resultItensCalendario[i].attributes[2].value == data) {
          resultItensCalendario[i].classList.add("item");
          setSolicitacaoSelecionada(
            resultItensCalendario[i].attributes[3].value
          );
          break;
        }
      }
    }
  }, [data]);

  function getSolicitacaoUnica() {
    history.push({
      pathname: `/solicitacoes/acompanhar-solicitacao/${solicitacaoSelecionada}`,
    });
  }

  function filtraPorMesSelecionado() {
    let resultFilter = [];
    resultFilter = agendamentosImovelSelecionadoOriginal.filter(
      (dia) =>
        dia.compromissoServico?.schedStartTime.split("-")[1] == dataAtual.mes &&
        dia.compromissoServico?.schedStartTime.split("-")[0] == dataAtual.ano
    );
    setAgendamentosImovelSelecionado(resultFilter);
  }

  // retornar os agendamentos para o imóvel selecionado
  function filtraImovel() {
    let resultFiltroImovel = todosAgendamentos.filter((solicitacao) => {
      return solicitacao.ativo == imovelSelecionado;
    });
    setAgendamentosImovelSelecionado(resultFiltroImovel);
    setAgendamentosImovelSelecionadoOriginal(resultFiltroImovel);

    loadDiasDisponiveis(resultFiltroImovel);
  }

  // seleciona somente os dias com agendamento para passar para o calendário
  function loadDiasDisponiveis(resultFiltroImovel) {
    let tempDiasDisponiveis = [];

    resultFiltroImovel.forEach((resultado) => {
      tempDiasDisponiveis.push(
        resultado.compromissoServico?.schedStartTime.split("T")[0]
      );
    });

    ordenaDiasComAgendamento(tempDiasDisponiveis);
    setDiasComAgendamentos(tempDiasDisponiveis);
  }

  function ordenaDiasComAgendamento(agendamentos) {
    agendamentos.sort(function (a, b) {
      return new Date(a).getTime() - new Date(b).getTime();
    });
  }

  async function loadAgendamentos() {
    let resultGetTodosAgendamentos = await getAgendamentosAbertos();

    if (!resultGetTodosAgendamentos) setError(true);
    else {
      setTodosAgendamentos(resultGetTodosAgendamentos);

      loadListaImoveis(resultGetTodosAgendamentos);
    }
  }

  // função que carrega a lista de imóveis somente com os imóveis que tenham agendamentos
  function loadListaImoveis(resultGetTodosAgendamentos) {
    let tempArrayAgendamentos = [];
    let result = [];
    let tempResult = [];

    // monta um array com todos nome dos imóveis
    resultGetTodosAgendamentos.forEach((item) => {
      tempArrayAgendamentos.push(item.ativo);
    });

    // filtra removendo imóveis duplicados
    result = tempArrayAgendamentos.filter(
      (item, index) => tempArrayAgendamentos.indexOf(item) == index
    );
    result?.forEach((item) => {
      tempResult.push({ nome: item });
    });

    setImovelSelecionado(tempResult[0]?.nome);
    setImoveis(tempResult);

    setLoading(false);
    executeScroll();
  }

  // para scroll
  const refCalendarioAcompanhamento = useRef(null);
  const executeScroll = () =>
    refCalendarioAcompanhamento.current.scrollIntoView();
  // fim scroll

  if (error)
    return (
      <p>Serviço temporariamente indisponível, tente novamente mais tarde.</p>
    );

  return (
    <>
      <HeaderStroke name="Meus agendamentos" msgDadosCadastrais={true} />
      {loading ? (
        <Spinner />
      ) : (
        <BaseComponent>
          <div
            ref={refCalendarioAcompanhamento}
            className="centralized-column acompanhamentoAgendamento"
          >
            {imoveis.length == 1 && (
              <DropDownDisabled nomeDropDown={"Imóvel"}>
                {imovelSelecionado}
              </DropDownDisabled>
            )}

            {imoveis.length > 1 && (
              <DropDown
                itens={imoveis}
                idDropDown={"calendarioAgendamentos"}
                setValue={setImovelSelecionado}
                label="Imóvel"
                nomeDropDown="SELECIONE O IMÓVEL DESEJADO"
                overflow="hidden"
                alturaMinima="120px"
                nomeSelecionado={imovelSelecionado}
                btnClose={false}
              />
            )}
            <Calendar
              setDataAtual={setDataAtual}
              diasDisponiveis={diasComAgendamentos}
              largura="375px"
              altura="340px"
              setData={setData}
            />
            <div className="acompanhamentoAgendamento__detalhes centralized">
              <div className="agendamentos centralized-column">
                {agendamentosImovelSelecionado
                  .sort(function (a, b) {
                    return (
                      new Date(a.compromissoServico?.schedStartTime).getTime() -
                      new Date(b.compromissoServico?.schedStartTime).getTime()
                    );
                  })
                  .map((agendamento) => (
                    <div
                      key={agendamento.caseNumber}
                      className="centralized"
                      onClick={() => {
                        setSolicitacaoSelecionada(agendamento.id);
                        Array.from(
                          document.getElementsByClassName("itemDoCalendario")
                        ).forEach((item) => {
                          item.classList.remove("item");
                          if (item.accessKey == agendamento.caseNumber) {
                            item.classList.add("item");
                          }
                        });
                      }}
                    >
                      <div
                        key={agendamento.caseNumber}
                        accessKey={agendamento.caseNumber}
                        className="centralized itemDoCalendario"
                        dataagendamento={
                          agendamento.compromissoServico?.schedStartTime.split(
                            "T"
                          )[0]
                        }
                        idAgendamento={agendamento.id}
                        style={{
                          width: "100%",
                          cursor: "pointer",
                          padding: "10px",
                        }}
                      >
                        <p style={{ fontWeight: "900" }}>
                          {agendamento.caseNumber}
                        </p>
                        <div className="centralized-column">
                          <span>{agendamento.subject}</span>
                          <span>
                            {agendamento.compromissoServico?.schedStartTime
                              .split("T")[0]
                              .split("-")
                              .reverse()
                              .join("/")}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            <BotaoMenor
              disabled={
                Object.entries(solicitacaoSelecionada).length == 0
                  ? true
                  : false
              }
              onClick={() => {
                getSolicitacaoUnica();
              }}
            >
              ACOMPANHAR
            </BotaoMenor>
          </div>
        </BaseComponent>
      )}
    </>
  );
};

export default AcompanharAgendamentos;
